<div class="d-flex flex-column gap-4">
  <div class="title-md" i18n>Employee Participation</div>
  <div class="d-flex flex-column gap-4" [formGroup]="formGroup">
    <!-- Row 1 -->
    <div class="d-flex align-items-start">
      <!-- First column -->
      <div class="d-flex flex-column gap-1" style="width: 20.312rem">
        <label class="form-input-label" [for]="'fullTimeParticipationType'" i18n> Full Time Participation </label>
        <app-text-input
          formControlName="fullTimeParticipationType"
          controlId="fullTimeParticipationType"
          [error]="formSubmitted && formGroup.controls.fullTimeParticipationType.invalid" />
        <app-form-error
          *ngIf="formSubmitted && formGroup.controls.fullTimeParticipationType.invalid"
          [customErrorMessages]="customErrorMessages.fullTimeParticipationType"
          [errors]="formGroup.controls.fullTimeParticipationType.errors" />
      </div>
      <!-- Second column -->
      <div class="d-flex" style="flex: 2">
        <div class="d-flex" style="height: 100%">
          <img
            class="vert-form-divider"
            alt="divider"
            i18n-alt
            [src]="'assets/icons/employer-plan-config/vertical-form-divider.svg'" />
        </div>
        <!-- Waiting Period -->
        <div class="d-flex flex-column gap-1" style="width: 12.5rem">
          <label class="form-input-label" [for]="'fullTimeWaitingPeriod'" i18n> Waiting Period (months) </label>
          <app-numeric-input
            formControlName="fullTimeWaitingPeriod"
            controlId="fullTimeWaitingPeriod"
            [max]="24"
            [error]="formSubmitted && formGroup.controls.fullTimeWaitingPeriod.invalid" />
          <div class="form-input-hint" i18n>Can not exceed 24 months</div>
          <app-form-error
            *ngIf="formSubmitted && formGroup.controls.fullTimeWaitingPeriod.invalid"
            [customErrorMessages]="customErrorMessages.fullTimeWaitingPeriod"
            [errors]="formGroup.controls.fullTimeWaitingPeriod.errors" />
        </div>
      </div>
    </div>

    <!-- Row 2 -->
    <div class="d-flex align-items-start">
      <!-- First column -->
      <div class="d-flex flex-column gap-1" style="width: 20.312rem">
        <label class="form-input-label" [for]="'lessThanFullTimeParticipationTypeId'" i18n
          >Less than Full Time Participation</label
        >
        <app-dropdown-input
          formControlName="lessThanFullTimeParticipationTypeId"
          controlId="lessThanFullTimeParticipationTypeId"
          [dropdowns]="lessThanFullTimeParticipationDropdownItems"
          [error]="formSubmitted && formGroup.controls.lessThanFullTimeParticipationTypeId.invalid" />
        <app-form-error
          *ngIf="formSubmitted && formGroup.controls.lessThanFullTimeParticipationTypeId.invalid"
          [customErrorMessages]="customErrorMessages.lessThanFullTimeParticipationTypeId"
          [errors]="formGroup.controls.lessThanFullTimeParticipationTypeId.errors" />
      </div>
      <!-- Second column -->
      <div class="d-flex" style="flex: 2">
        <div class="d-flex" style="height: 100%">
          <img
            class="vert-form-divider"
            alt="divider"
            i18n-alt
            [src]="'assets/icons/employer-plan-config/vertical-form-divider.svg'" />
        </div>
        <!-- Waiting Period -->
        <div class="d-flex flex-column gap-1" style="width: 12.5rem">
          <label class="form-input-label" [for]="'lessThanFullTimeWaitingPeriod'" i18n> Waiting Period (months) </label>
          <app-numeric-input
            formControlName="lessThanFullTimeWaitingPeriod"
            controlId="lessThanFullTimeWaitingPeriod"
            [max]="24"
            [error]="formSubmitted && formGroup.controls.lessThanFullTimeWaitingPeriod.invalid" />
          <div class="form-input-hint" i18n>Can not exceed 24 months</div>
          <app-form-error
            *ngIf="formSubmitted && formGroup.controls.lessThanFullTimeWaitingPeriod.invalid"
            [customErrorMessages]="customErrorMessages.lessThanFullTimeWaitingPeriod"
            [errors]="formGroup.controls.lessThanFullTimeWaitingPeriod.errors" />
        </div>
      </div>
    </div>
  </div>
</div>
